import styled from 'styled-components';

export const PopupBlock = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: 0.4s ease;

  &.show-popup {
    opacity: 1;
    visibility: visible;

    .popup-content {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .popup-content {
    padding: 40px;
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    min-width: 500px;
    max-width: 650px;
    transition: 0.4s ease;
    transform: translateY(-45px);
    opacity: 0;

    .close-popup {
      position: absolute;
      background-color: transparent;
      border: none;
      top: 15px;
      right: 15px;
    }

    h3 {
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 40px;
    }

    .popup-heading {
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
    }

    .custom-select {
      width: 100px;

      .css-yk16xz-control {
        border: none;
      }
    }
  }

  .upgrade-popup {
    h3 {
      margin: 25px 0 10px;
    }

    p {
      margin: 0 auto;
      font-size: 16px;
    }
  }
`;
